module.exports = __webpack_public_path__ + "static/media/tambaqui-inteiro.da45963a.jpg";